// // import React, { useState } from 'react';
// // import { Formik, Form } from 'formik';
// // import * as Yup from 'yup';
// // import {
// //   Button,
// //   TextField,
// //   CircularProgress,
// // } from '@mui/material';
// // import { styled } from '@mui/material/styles';
// // import ConsumerFormFields from './ConsumerFormFields';
// // import ConfirmDialog from '../../../components/ConfirmDialog';
// // import SuccessSnackbar from '../../../components/SuccessSnackbar';
// // import FormContainerWrapper from '../../../components/FormContainerWrapper';
// // import { useAuth } from '../../../AuthContext';
// // // Validation schema using Yup
// // const consumerSchema = Yup.object().shape({
// //   name: Yup.string()
// //     .min(2, 'Name must be at least 2 characters')
// //     .max(50, 'Name must be less than 50 characters')
// //     .required('Name is required'),
// //   mobileNumber: Yup.string()
// //     .matches(/^\d{10}$/, 'Mobile Number must be exactly 10 digits')
// //     .required('Mobile Number is required'),
// //   farmAddress: Yup.string()
// //     .min(5, 'Farm Address must be at least 5 characters')
// //     .required('Farm Address is required'),
// //   serviceNumber: Yup.string()
// //     .min(3, 'Service Number must be at least 3 characters')
// //     .required('Service Number is required'),
// //   pumpsOwned: Yup.number()
// //     .min(0, 'Pumps Owned cannot be negative')
// //     .required('Pumps Owned is required'),
// // });

// // // Styled components
// // const SubmitButton = styled(Button)(({ theme }) => ({
// //   marginTop: theme.spacing(4),
// //   padding: theme.spacing(1.5),
// //   borderRadius: '10px',
// //   backgroundColor: '#1976d2',
// //   fontWeight: 'bold',
// //   fontSize: '1rem',
// //   '&:hover': {
// //     backgroundColor: '#1565c0',
// //   },
// // }));

// // const ActionButton = styled(Button)(({ theme }) => ({
// //   marginTop: theme.spacing(4),
// //   padding: theme.spacing(1.5),
// //   borderRadius: '10px',
// //   fontWeight: 'bold',
// //   fontSize: '1rem',
// // }));

// // const ConsumerUpdateDelete = () => {
// //   const [consumerData, setConsumerData] = useState(null);
// //   const [searchMobileNumber, setSearchMobileNumber] = useState('');
// //   const [loading, setLoading] = useState(false);
// //   const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
// //   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
// //   const [openSuccessSnackbar, setOpenSuccessSnackbar] = useState(false);
// //   const [successMessage, setSuccessMessage] = useState('');
// //   const [formValues, setFormValues] = useState(null);
// //   const { consumers,updateConsumer, deleteConsumer } = useAuth();

// //   const handleSearch = async () => {
// //     if (searchMobileNumber.length === 10 && /^\d{10}$/.test(searchMobileNumber)) {
// //       setLoading(true);
// //       const data = consumers.find((consumer) => consumer.mobile_number === searchMobileNumber);
// //       setConsumerData(data || null);
// //       setLoading(false);
// //       if (!data) {
// //         setSuccessMessage('Mobile Number not found. Please enter a valid 10 digit mobile Number');
// //         setOpenSuccessSnackbar(true);
// //       }
// //     } else {
// //       setConsumerData(null);
// //       setSuccessMessage('Please enter a valid 10-digit Mobile Number');
// //       setOpenSuccessSnackbar(true);
// //     }
// //   };

// //   const handleUpdateSubmit = (values) => {
// //     setFormValues(values);
// //     setOpenConfirmDialog(true);
// //   };

// //   const handleConfirmUpdate = async() => {
// //     try {
// //       await updateConsumer(formValues.mobileNumber, formValues);
// //       setOpenConfirmDialog(false);
// //       setSuccessMessage(`Consumer ${formValues.name} Updated Successfully!`);
// //        setOpenSuccessSnackbar(true);
// //     } catch (error) {
// //       setSuccessMessage('Failed to update Consumer. Please try again.');
// //       setOpenSuccessSnackbar(true);
// //     }
// //     setConsumerData(formValues);
// //   };

// //   const handleCloseSuccess = () => {
// //     setOpenSuccessSnackbar(false);
// //   };

// //   return (
// //     <FormContainerWrapper title="Update or Delete Consumer">
// //       <div className="mb-6">
// //         <TextField
// //           label="Search by Mobile Number (10 digits)"
// //           variant="outlined"
// //           fullWidth
// //           value={searchMobileNumber}
// //           onChange={(e) => setSearchMobileNumber(e.target.value)}
// //           margin="normal"
// //           InputLabelProps={{
// //             shrink: true,
// //             sx: {
// //               fontSize: '1.2rem',
// //               '&.Mui-focused': {
// //                 fontSize: '1.2rem',
// //                 color: '#1976d2',
// //               },
// //             },
// //           }}
// //           InputProps={{
// //             notched: true,
// //             sx: {
// //               '& .MuiOutlinedInput-notchedOutline legend': {
// //                 fontSize: '0.9rem',
// //                 width: 'max-content',
// //               },
// //             },
// //           }}
// //           error={searchMobileNumber && !/^\d{10}$/.test(searchMobileNumber)}
// //           helperText={
// //             searchMobileNumber && !/^\d{10}$/.test(searchMobileNumber)
// //               ? 'Mobile Number must be exactly 10 digits'
// //               : ''
// //           }
// //         />
// //         <SubmitButton
// //           variant="contained"
// //           fullWidth
// //           onClick={handleSearch}
// //           disabled={loading}
// //         >
// //           {loading ? <CircularProgress size={24} /> : 'Search'}
// //         </SubmitButton>
// //       </div>
// //       {consumerData && (
// //         <Formik
// //           initialValues={consumerData}
// //           validationSchema={consumerSchema}
// //           onSubmit={handleUpdateSubmit}
// //           enableReinitialize
// //         >
// //           {({ errors, touched }) => (
// //             <Form>
// //               <ConsumerFormFields errors={errors} touched={touched} disabledFields={['mobileNumber']} />
// //               <div className="flex justify-end space-x-4">
// //                 <ActionButton
// //                   variant="contained"
// //                   color="primary"
// //                   type="submit"
// //                 >
// //                   Update
// //                 </ActionButton>
// //               </div>
// //             </Form>
// //           )}
// //         </Formik>
// //       )}

// //       <ConfirmDialog
// //         open={openConfirmDialog}
// //         onClose={() => setOpenConfirmDialog(false)}
// //         onConfirm={handleConfirmUpdate}
// //         title="Confirm Updated Consumer Details"
// //         content={
// //           formValues && (
// //             <div className="space-y-2">
// //               <p><strong>Name:</strong> {formValues.name}</p>
// //               <p><strong>Mobile Number:</strong> {formValues.mobileNumber}</p>
// //               <p><strong>Farm Address:</strong> {formValues.farmAddress}</p>
// //               <p><strong>Service Number:</strong> {formValues.serviceNumber}</p>
// //               <p><strong>Pumps Owned:</strong> {formValues.pumpsOwned}</p>
// //               <p><strong>Login Username:</strong> {formValues.loginUsername}</p>
// //               <p><strong>Login Password:</strong> {formValues.loginPassword}</p>
// //             </div>
// //           )
// //         }
// //       />
// //       <SuccessSnackbar
// //         open={openSuccessSnackbar}
// //         onClose={handleCloseSuccess}
// //         message={successMessage}
// //         severity={successMessage.includes('Successfully') ? 'success' : 'error'}
// //       />
// //     </FormContainerWrapper>
// //   );
// // };

// // export default ConsumerUpdateDelete;

// import React, { useState } from "react";
// import { Formik, Form } from "formik";
// import * as Yup from "yup";
// import { Button, TextField, CircularProgress } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import ConsumerFormFields from "./ConsumerFormFields";
// import ConfirmDialog from "../../../components/ConfirmDialog";
// import SuccessSnackbar from "../../../components/SuccessSnackbar";
// import FormContainerWrapper from "../../../components/FormContainerWrapper";
// import { useAuth } from "../../../AuthContext";

// // Validation schema using Yup
// const consumerSchema = Yup.object().shape({
//   name: Yup.string()
//     .min(2, "Name must be at least 2 characters")
//     .max(50, "Name must be less than 50 characters")
//     .required("Name is required"),
//   mobile_number: Yup.string()
//     .matches(/^\d{10}$/, "Mobile Number must be exactly 10 digits")
//     .required("Mobile Number is required"),
//   farm_address: Yup.string()
//     .min(5, "Farm Address must be at least 5 characters")
//     .required("Farm Address is required"),
//   service_number: Yup.string()
//     .min(3, "Service Number must be at least 3 characters")
//     .required("Service Number is required"),
//   imei_list: Yup.array()
//     .min(1, "At least one pump must be selected")
//     .max(1,"Only one pump can be chosen per customer")
//     .required("Pumps selection is required"),
//      password: Yup.string()
//         .min(8, 'Password must be at least 8 characters')
        
// });

// // Styled components
// const SubmitButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(4),
//   padding: theme.spacing(1.5),
//   borderRadius: "10px",
//   backgroundColor: "#1976d2",
//   fontWeight: "bold",
//   fontSize: "1rem",
//   "&:hover": {
//     backgroundColor: "#1565c0",
//   },
// }));

// const ActionButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(4),
//   padding: theme.spacing(1.5),
//   borderRadius: "10px",
//   fontWeight: "bold",
//   fontSize: "1rem",
// }));

// const ConsumerUpdateDelete = () => {
//   const [consumerData, setConsumerData] = useState(null);
//   const [searchMobileNumber, setSearchMobileNumber] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
//   const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [formValues, setFormValues] = useState(null);
//   const { consumers, updateConsumer, deleteConsumer, pumpsWithImei } =
//     useAuth();

//   const handleSearch = async () => {
//     if (
//       searchMobileNumber.length === 10 &&
//       /^\d{10}$/.test(searchMobileNumber)
//     ) {
//       setLoading(true);
//       {
//         try {
//           const response = await fetch(
//             `http://3.109.202.91/consumer/${searchMobileNumber}`
//           );

//           if (!response.ok) {
//             const errorData = await response.json();
//             // Create a new error with the API error message
//             const error = new Error(
//               errorData.message || "Failed to find mobile number"
//             );
//             error.response = response; // Attach response to error for handling
//             throw error;
//           }
//           const data = await response.json();
//           setConsumerData(data);
//           setLoading(false);
//         } catch (error) {
//          // console.log( "the error is from consumer update delete",error.message);
//           if (error.message) {
//             setSnackbarMessage(error.message);
//           } else {
//             setSnackbarMessage(
//               "Mobile Number not found. Please enter a valid 10 digit mobile Number"
//             );
//           }
//           setSnackbarSeverity("error");
//           setOpenSnackbar(true);
//           setLoading(false);
//         }
//       }
//     } else {
//       setConsumerData(null);
//       setSnackbarMessage("Please enter a valid 10-digit Mobile Number");
//       setSnackbarSeverity("error");
//       setOpenSnackbar(true);
//     }
//   };

//   const handleUpdateSubmit = (values) => {
//     setFormValues(values);
//     setOpenConfirmDialog(true);
//   };

//   const handleConfirmUpdate = async () => {
//     try {
//       if (!formValues) return;
// //console.log('this is the password,formvalue passwoerd',formValues.password)
//       // Prepare the data for API
//       const apiData = {
//         ...formValues,
//         username: formValues.mobile_number,
//       };
//       // Explicitly remove password if it's empty or only whitespace
// if (!formValues.password || formValues.password.trim() === '') {
//   delete apiData.password;
// }

//       await updateConsumer(searchMobileNumber, apiData);
//       setOpenConfirmDialog(false);

//       // Update local state with new data
//       setConsumerData(apiData);

//       setSnackbarMessage(`Consumer ${formValues.name} Updated Successfully!`);
//       setSnackbarSeverity("success");
//       setOpenSnackbar(true);
//       setSearchMobileNumber('')
//     } catch (error) {
//       setOpenConfirmDialog(false);

//       let errorMsg = "Failed to update consumer. Please try again.";
//       // if (error.message.includes("Mobile number already exists")) {
//       //   errorMsg =
//       //     "This mobile number is already registered. Please use a different number.";
//       // } else if (error.response) {
//       //   try {
//       //     const errorData = await error.response.json();
//       //     errorMsg = errorData.error || errorMsg;
//       //   } catch (e) {
//       //     console.error("Error parsing error response:", e);
//       //   }
//       // }

//       setSnackbarMessage(errorMsg);
//       setSnackbarSeverity("error");
//       setOpenSnackbar(true);
//     }
//     finally{
//       setConsumerData(null);
//     }
//   };

//   const handleDelete = () => {
//     setOpenDeleteDialog(true);
//   };

//   // const handleConfirmDelete = async () => {
//   //   try {
//   //     if (!consumerData) return;
//   //     await deleteConsumer(consumerData.mobile_number);
//   //     setOpenDeleteDialog(false);
//   //     setSnackbarMessage(`Consumer ${consumerData.name} Deleted Successfully!`);
//   //     setSnackbarSeverity('success');
//   //     setOpenSnackbar(true);
//   //     setConsumerData(null);
//   //     setSearchMobileNumber('');
//   //   } catch (error) {
//   //     setSnackbarMessage('Failed to delete consumer. Please try again.');
//   //     setSnackbarSeverity('error');
//   //     setOpenSnackbar(true);
//   //   }
//   // };

//   const handleCloseSnackbar = () => {
//     setOpenSnackbar(false);
//     setTimeout(() => {
//       setSnackbarMessage("");
//       setSnackbarSeverity("success");
//     }, 300);
//   };

//   return (
//     <FormContainerWrapper title="Update or Delete Consumer">
//       <div className="mb-6">
//         <TextField
//           label="Search by Mobile Number (10 digits)"
//           variant="outlined"
//           fullWidth
//           value={searchMobileNumber}
//           onChange={(e) => setSearchMobileNumber(e.target.value)}
//           margin="normal"
//           InputLabelProps={{
//             shrink: true,
//             sx: {
//               fontSize: "1.2rem",
//               "&.Mui-focused": {
//                 fontSize: "1.2rem",
//                 color: "#1976d2",
//               },
//             },
//           }}
//           InputProps={{
//             notched: true,
//             sx: {
//               "& .MuiOutlinedInput-notchedOutline legend": {
//                 fontSize: "0.9rem",
//                 width: "max-content",
//               },
//             },
//           }}
//           error={searchMobileNumber && !/^\d{10}$/.test(searchMobileNumber)}
//           helperText={
//             searchMobileNumber && !/^\d{10}$/.test(searchMobileNumber)
//               ? "Mobile Number must be exactly 10 digits"
//               : ""
//           }
//         />
//         <SubmitButton
//           variant="contained"
//           fullWidth
//           onClick={handleSearch}
//           disabled={loading}
//         >
//           {loading ? <CircularProgress size={24} /> : "Search"}
//         </SubmitButton>
//       </div>

//       {consumerData && (
//         <Formik
//           initialValues={{
//             ...consumerData,
//             // Ensure pumpsOwned is properly initialized
//             //pumpsOwned: consumerData.imei_list || [],
//           }}
//           validationSchema={consumerSchema}
//           onSubmit={handleUpdateSubmit}
//           enableReinitialize
//         >
//           {({ errors, touched, setFieldValue, values }) => (
//             <Form>
//               <ConsumerFormFields
//                 errors={errors}
//                 touched={touched}
//                 pumps={pumpsWithImei}
//                 setFieldValue={setFieldValue}
//                 values={values}
//                 disabledFields={[]}
//                 update={true}
//               />
//               <div className="flex justify-end space-x-4">
//                 <ActionButton variant="contained" color="primary" type="submit">
//                   Update
//                 </ActionButton>
//                 {/* <ActionButton
//                   variant="outlined"
//                   color="error"
//                   onClick={handleDelete}
//                 >
//                   Delete
//                 </ActionButton> */}
//               </div>
//             </Form>
//           )}
//         </Formik>
//       )}

//       <ConfirmDialog
//         open={openConfirmDialog}
//         onClose={() => setOpenConfirmDialog(false)}
//         onConfirm={handleConfirmUpdate}
//         title="Confirm Updated Consumer Details"
//         content={
//           formValues && (
//             <div className="space-y-2">
//               <p>
//                 <strong>Name:</strong> {formValues.name}
//               </p>
//               <p>
//                 <strong>Mobile Number:</strong> {formValues.mobile_number}
//               </p>
//               <p>
//                 <strong>Farm Address:</strong> {formValues.farm_address}
//               </p>
//               <p>
//                 <strong>Service Number:</strong> {formValues.service_number}
//               </p>
//               <p>
//                 <strong>Pumps Owned:</strong>{" "}
//                 {formValues.imei_list?.join(", ") || "None"}
//               </p>
//               <p>
//                 <strong>Login Username:</strong> {formValues.mobile_number}
//               </p>
//             </div>
//           )
//         }
//       />
//       {/* 
//       <ConfirmDialog
//         open={openDeleteDialog}
//         onClose={() => setOpenDeleteDialog(false)}
//         onConfirm={handleConfirmDelete}
//         title="Confirm Consumer Deletion"
//         content={
//           <p>
//             Are you sure you want to delete the consumer <strong>{consumerData?.name}</strong>?
//             This action cannot be undone.
//           </p>
//         }
//         confirmText="Delete"
//         confirmColor="error"
//       /> */}

//       <SuccessSnackbar
//         open={openSnackbar}
//         onClose={handleCloseSnackbar}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         autoHideDuration={snackbarSeverity === "error" ? 6000 : 3000}
//       />
//     </FormContainerWrapper>
//   );
// };

// export default ConsumerUpdateDelete;




import React, { useState } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { Button, TextField, CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';
import ConsumerFormFields from './ConsumerFormFields';
import ConfirmDialog from '../../../components/ConfirmDialog';
import SuccessSnackbar from '../../../components/SuccessSnackbar';
import FormContainerWrapper from '../../../components/FormContainerWrapper';
import { useAuth } from '../../../AuthContext';

// Validation schema using Yup
const consumerSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name must be less than 50 characters')
    .required('Name is required'),
  mobile_number: Yup.string()
    .matches(/^\d{10}$/, 'Mobile Number must be exactly 10 digits')
    .required('Mobile Number is required'),
  farm_address: Yup.string()
    .min(5, 'Farm Address must be at least 5 characters')
    .required('Farm Address is required'),
  service_number: Yup.string()
    .min(3, 'Service Number must be at least 3 characters')
    .required('Service Number is required'),
  imei_list: Yup.array()
    .of(Yup.string())
    .min(1, 'Please select one pump')
    .max(1, 'Only one pump can be selected')
    .required('Pumps selection is required'),
  password: Yup.string()
    .min(8, 'Password must be at least 8 characters'),
     panel_number_list: Yup.array()
                .of(Yup.string())
                .min(1, 'Please enter atleast one Panel No')
                .required('Panel number is required'),
  geolocation: Yup.array()
    .of(Yup.number().nullable())
    .length(2, 'Geolocation must contain exactly two values (latitude, longitude)')
    .test('latitude', 'Latitude must be between -90 and 90', (value) =>
      value && value[0] !== null ? value[0] >= -90 && value[0] <= 90 : true
    )
    .test('longitude', 'Longitude must be between -180 and 180', (value) =>
      value && value[1] !== null ? value[1] >= -180 && value[1] <= 180 : true
    )
    .nullable(),
      panel_number_list: Yup.array()
                .of(Yup.string())
                .min(1, 'Please enter atleast one Panel No')
                .required('Panel number is required'),
});

// Styled components
const SubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(1.5),
  borderRadius: '10px',
  backgroundColor: '#1976d2',
  fontWeight: 'bold',
  fontSize: '1rem',
  '&:hover': {
    backgroundColor: '#1565c0',
  },
}));

const ActionButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(4),
  padding: theme.spacing(1.5),
  borderRadius: '10px',
  fontWeight: 'bold',
  fontSize: '1rem',
}));

const ConsumerUpdateDelete = () => {
  const [consumerData, setConsumerData] = useState(null);
  const [searchMobileNumber, setSearchMobileNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [formValues, setFormValues] = useState(null);
  const { consumers, updateConsumer, deleteConsumer, pumpsWithImei,authorizedFetch } = useAuth();

  const handleSearch = async () => {
    if (searchMobileNumber.length === 10 && /^\d{10}$/.test(searchMobileNumber)) {
      setLoading(true);
      try {
        const response = await authorizedFetch(`/consumer/${searchMobileNumber}`);
        if (!response.ok) {
          const errorData = await response.json();
          const error = new Error(errorData.message || 'Failed to find mobile number');
          error.response = response;
          throw error;
        }
        const data = await response.json();
        setConsumerData(data);
        setLoading(false);
      } catch (error) {
        setSnackbarMessage(error.message || 'Mobile Number not found. Please enter a valid 10 digit mobile Number');
        setSnackbarSeverity('error');
        setOpenSnackbar(true);
        setLoading(false);
      }
    } else {
      setConsumerData(null);
      setSnackbarMessage('Please enter a valid 10-digit Mobile Number');
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    }
  };

  const handleUpdateSubmit = (values) => {
    setFormValues(values);
    setOpenConfirmDialog(true);
  };

  const handleConfirmUpdate = async () => {
    try {
      if (!formValues) return;
      const apiData = {
        ...formValues,
        username: formValues.mobile_number,
      };
      if (!formValues.password || formValues.password.trim() === '') {
        delete apiData.password;
      }
      await updateConsumer(searchMobileNumber, apiData);
      setOpenConfirmDialog(false);
      setConsumerData(apiData);
      setSnackbarMessage(`Consumer ${formValues.name} Updated Successfully!`);
      setSnackbarSeverity('success');
      setOpenSnackbar(true);
      setSearchMobileNumber('');
    } catch (error) {
      setOpenConfirmDialog(false);
      let errorMsg = 'Failed to update consumer. Please try again.';
      setSnackbarMessage(errorMsg);
      setSnackbarSeverity('error');
      setOpenSnackbar(true);
    } finally {
      setConsumerData(null);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
    setTimeout(() => {
      setSnackbarMessage('');
      setSnackbarSeverity('success');
    }, 300);
  };

  return (
    <FormContainerWrapper title="Update Existing Consumer">
      <div className="mb-6">
        <TextField
          label="Search by Mobile Number (10 digits)"
          variant="outlined"
          fullWidth
          value={searchMobileNumber}
          onChange={(e) => setSearchMobileNumber(e.target.value)}
          margin="normal"
          InputLabelProps={{
            shrink: true,
            sx: {
              fontSize: '1.2rem',
              '&.Mui-focused': {
                fontSize: '1.2rem',
                color: '#1976d2',
              },
            },
          }}
          InputProps={{
            notched: true,
            sx: {
              '& .MuiOutlinedInput-notchedOutline legend': {
                fontSize: '0.9rem',
                width: 'max-content',
              },
            },
          }}
          error={searchMobileNumber && !/^\d{10}$/.test(searchMobileNumber)}
          helperText={
            searchMobileNumber && !/^\d{10}$/.test(searchMobileNumber)
              ? 'Mobile Number must be exactly 10 digits'
              : ''
          }
        />
        <SubmitButton
          variant="contained"
          fullWidth
          onClick={handleSearch}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : 'Search'}
        </SubmitButton>
      </div>

      {consumerData && (
        <Formik
          initialValues={{
            name: consumerData.name || '',
            mobile_number: consumerData.mobile_number || '',
            farm_address: consumerData.farm_address || '',
            service_number: consumerData.service_number || '',
            imei_list: consumerData.imei_list || [],
            geolocation: consumerData.geolocation || ['', ''],
            panel_number_list:consumerData.panel_number_list ||[],
            username: consumerData.mobile_number || '',
            password: '',
            
          }}
          validationSchema={consumerSchema}
          onSubmit={handleUpdateSubmit}
          enableReinitialize
        >
          {({ errors, touched, setFieldValue, values }) => (
            <Form>
              <ConsumerFormFields
                errors={errors}
                touched={touched}
                pumps={pumpsWithImei}
                setFieldValue={setFieldValue}
                values={values}
                disabledFields={['mobile_number']}
                update={true}
              />
              <div className="flex justify-end space-x-4">
                <ActionButton variant="contained" color="primary" type="submit">
                  Update
                </ActionButton>
              </div>
            </Form>
          )}
        </Formik>
      )}

      <ConfirmDialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        onConfirm={handleConfirmUpdate}
        title="Confirm Updated Consumer Details"
        content={
          formValues && (
            <div className="space-y-2">
              <p><strong>Name:</strong> {formValues.name}</p>
              <p><strong>Mobile Number:</strong> {formValues.mobile_number}</p>
              <p><strong>Farm Address:</strong> {formValues.farm_address}</p>
              <p><strong>Service Number:</strong> {formValues.service_number}</p>
              <p><strong>Pump:</strong> {formValues.imei_list?.join(', ') || 'None'}</p>
              <p><strong>Geolocation:</strong> {formValues.geolocation?.[0] && formValues.geolocation?.[1] ? `[${formValues.geolocation[0]}, ${formValues.geolocation[1]}]` : 'Not provided'}</p>
                <p><strong>Panel No:</strong> {formValues.panel_number_list?.join(', ') || 'None'}</p>
              <p><strong>Login Username:</strong> {formValues.mobile_number}</p>
            </div>
          )
        }
      />

      <SuccessSnackbar
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        message={snackbarMessage}
        severity={snackbarSeverity}
        autoHideDuration={snackbarSeverity === 'error' ? 6000 : 3000}
      />
    </FormContainerWrapper>
  );
};

export default ConsumerUpdateDelete;
//lower limit and outer limit gets converge to pin point to the 